import { Button, Form, Input, Select } from 'antd';
import styles from './AddingIngredients.module.scss';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { IIngredient, TLanguage } from '../../../types';
import { IConfigOption, fieldPlaceholder } from '../AddingInfo/config';

const unitOptions: IConfigOption = {
  eng: [
    { value: 'ml', label: 'ml' },
    { value: 'dash(es)', label: 'dash(es)' },
    { value: 'g', label: 'g' },
    { value: 'pc(s)', label: 'pc(s)' },
  ],
  ru: [
    { value: 'мл', label: 'мл' },
    { value: 'дэш', label: 'дэш' },
    { value: 'гр', label: 'гр' },
    { value: 'шт', label: 'шт' },
  ],
};

const AddingIngredients = ({
  initialValues,
  lang,
}: {
  initialValues: IIngredient[];
  lang: TLanguage;
}) => {
  const initValues = initialValues?.map(value => {
    return { description: value.description, value: value.value, unit: value.unit };
  });

  return (
    <div className={styles.section}>
      <label>{fieldPlaceholder.ingredients[lang]}:</label>
      <div>
        <Form.List
          name={`${lang}_ingredients`}
          initialValue={initValues}
          rules={[
            {
              validator: async (_, data) => {
                if (!data || data.length < 1) {
                  return Promise.reject(new Error('At least 1 ingredient'));
                }
              },
            },
          ]}
        >
          {(fields, { add, remove }, { errors }) => {

            return (
              <>
                {fields.map(({ name, key, ...restField }) => (
                  <div className={styles.step} key={key}>
                    <Form.Item
                      {...restField}
                      name={[name, 'description']}
                      rules={[
                        {
                          required: true,
                          message: 'Requered field',
                        },
                      ]}
                    >
                      <Input placeholder={lang === 'eng' ? 'Name' : 'Название'} />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'value']}
                      rules={[
                        {
                          required: true,
                          message: 'Requered field',
                        },
                      ]}
                    >
                      <Input placeholder={lang === 'eng' ? 'Value' : 'Значение'} />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'unit']}
                      rules={[
                        {
                          message: 'Requered field',
                        },
                      ]}
                    >
                      <Select
                        options={unitOptions[lang]}
                        placeholder={lang === 'eng' ? 'Unit' : 'Ед.'}
                      />
                    </Form.Item>
                    <MinusCircleOutlined onClick={() => remove(name)} />
                  </div>
                ))}

                <Form.Item>
                  <Button
                    style={{ background: '#FFCC70', color: '#000' }}
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                  >
                    {lang === 'eng' ? 'Add ingredient' : 'Добавить ингредиент'}
                  </Button>
                  <Form.ErrorList errors={errors} />
                </Form.Item>
              </>
            );
          }}
        </Form.List>
      </div>
    </div>
  );
};

export default AddingIngredients;
